import React, { useState, useEffect } from "react";

// Responsive RingBar Component (same as before)
const RingBar = ({ percentage, color, centerLabel, subLabel }) => (
  <div
    style={{
      display: "inline-block",
      width: "40vw",
      maxWidth: "350px",
      minWidth: "180px",
      margin: "0 4vw",
      verticalAlign: "top"
    }}
  >
    <svg
      viewBox="0 0 300 300"
      width="100%"
      height="100%"
      style={{ display: "block" }}
    >
      <circle cx="150" cy="150" r="130" fill="none" stroke="#e5e5e5" strokeWidth="40" />
      <circle
        cx="150" cy="150" r="130" fill="none" stroke={color} strokeWidth="40"
        strokeDasharray={816}
        strokeDashoffset={816 - (percentage / 100) * 816}
        strokeLinecap="round"
        transform="rotate(-90 150 150)"
      />
      <text
        x="50%"
        y="50%"
        alignmentBaseline="middle"
        textAnchor="middle"
        fontWeight="bold"
        style={{
          dominantBaseline: "middle",
          fontSize: "clamp(20px, 2.5vw, 40px)"
        }}
      >
        {percentage}%
      </text>
    </svg>
    <div style={{ textAlign: "center" }}>
      <div style={{ fontWeight: "bold", fontSize: "clamp(11px, 1.3vw, 20px)" }}>{centerLabel}</div>
      <div style={{ fontSize: "clamp(12px, 1.4vw, 18px)" }}>{subLabel}</div>
    </div>
  </div>
);

const UserPlanDashboard = () => {
  const [userDetails, setUserDetails] = useState(null);
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  

    const plans_data = true;
useEffect(() => {
  // Retrieve your token (from localStorage, context, etc.)
  const token1 = localStorage.getItem('token');
  const token = localStorage.getItem('twitter_token');
  
  fetch('/api/get_specific_user', {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token1}`
    },
    body: JSON.stringify({ plans_data,  token }) // If your API expects token in body; else remove this line.
  })
    .then(res => res.json())
    .then(data => {
      setUserDetails(data.userDetails);
      setPlan(data.plan);
      setLoading(false);
    })
    .catch(() => setLoading(false));
}, []);

  // While loading or on failure
  if (loading) return <p>Loading...</p>;
  if (!userDetails || !plan) return <p>Unable to load plan info.</p>;

  // Calculations
  const percentPosts =
    userDetails.totalPostsAllocated > 0
      ? Math.round((userDetails.totalPostsDone / userDetails.totalPostsAllocated) * 100)
      : 0;

  const percentMessages =
    userDetails.totalMessagesAllocated > 0
      ? Math.round((userDetails.totalMessagesDone / userDetails.totalMessagesAllocated) * 100)
      : 0;

  // Responsive layout styles
  const gridStyle = {
    display: "grid",
    gridTemplateColumns: window.innerWidth <= 600 ? "1fr" : "1fr 1fr",
    gap: window.innerWidth <= 600 ? "6vw" : "5vw",
    width: "96%",
    maxWidth: "900px",
  };

  return (
    <div
      style={{
        textAlign: "center",
        display: "grid",
        justifyContent: "center"
      }}
    >
      <h1
        style={{
          display: "inline-block",
          background: "linear-gradient(90deg, #0c0c0cff 0%, #4747eb 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          color: "transparent",
          fontSize: "clamp(22px, 2.5vw, 60px)",
          marginBottom: 0
        }}
      >
        Your Plan
      </h1>
      <p style={{ fontSize: "clamp(12px, 1vw, 25px)" }}>
        You are Subscribed to {plan.name} Plan
      </p>

      <div style={gridStyle}>
        <RingBar
          percentage={percentPosts}
          color="#ff3636"
          centerLabel="Posts"
          subLabel={
            <>
              Posts Allocated: {userDetails.totalPostsAllocated} <br />
              Posts Done: {userDetails.totalPostsDone}
            </>
          }
        />
        <RingBar
          percentage={percentMessages}
          color="#38bad7"
          centerLabel="Messages"
          subLabel={
            <>
              Messages Allocated: {userDetails.totalMessagesAllocated} <br />
              Messages Done: {userDetails.totalMessagesDone}
            </>
          }
        />
      </div>
    </div>
  );
};

export default UserPlanDashboard;
